import _ from 'lodash';
import worldMap from '../map';
import translate from '../tools/translate';
import environment from '../../environment';

const drawing = (() => {
    let visible = false;
    let controls;
    let layer;
    let callback;

    const _add = e => {
        if(!environment.get('CONFIG.IS_AFTER_SALES')) {
            layer.clearLayers();
        }
        layer.addLayer(e.layer);

        tooltipArea(e);

        if (_.isFunction(callback)) {
            callback(e);
        }
    };

    const controlsOptions = {
        circle: {
            shapeOptions: {
                clickable: false,
                color: '#00B1FF',
                weight: 2
            },
            metric: ['km', 'm'],
            showArea: true
        },
        polygon: {
            allowIntersection: false,
            drawError: {
                color: '#FF193C',
                message: `<strong>Atenção!</strong> Polígono não aceito!`
            },
            shapeOptions: {
                color: '#00B1FF',
                weight: 2
            },
            metric: ['km', 'm'],
            showArea: true
        },
        rectangle: {
            shapeOptions: {
                clickable: false,
                color: '#00B1FF',
                weight: 2
            },
            metric: ['km', 'm'],
            showArea: true
        }
    };

    const createControls = (options) => {
        L.drawLocal.draw.toolbar.buttons.polygon = 'Polígono';
        L.drawLocal.draw.toolbar.buttons.rectangle = 'Retângulo';
        L.drawLocal.draw.toolbar.actions.title = 'Cancelar desenho';
        L.drawLocal.draw.toolbar.actions.text = 'Cancelar';
        L.drawLocal.draw.toolbar.undo.title = 'Deletar último ponto desenhado';
        L.drawLocal.draw.toolbar.undo.text = 'Deletar último ponto';
        L.drawLocal.draw.handlers.rectangle.tooltip.start = 'Clique e arraste para desenhar';
        L.drawLocal.draw.handlers.polygon.tooltip.start = 'Clique no mapa para iniciar o desenho';
        L.drawLocal.draw.handlers.polygon.tooltip.cont = 'Clique para continuar desenhando a forma';
        L.drawLocal.draw.handlers.polygon.tooltip.end = 'Clique no primeiro ponto para finalizar a forma';
        L.drawLocal.draw.handlers.simpleshape.tooltip.end = 'Solte o mouse para finalizar o desenho';

        return new L.Control.Draw(options);
    };

    const getLayer = () => layer;

    const show = (options, cb) => {
        if (visible) {
            return;
        }

        visible = true;
        callback = cb;

        if (!layer) {
            layer = new L.FeatureGroup();
            worldMap.addLayer(layer);
        }

        controls = createControls({
            position: 'bottomright',
            metric: false,
            draw: {
                polyline: options.polyline ? controlsOptions.polyline : false,
                polygon: options.polygon ? controlsOptions.polygon : false,
                circle: options.circle ? controlsOptions.circle : false,
                rectangle: options.rectangle ? controlsOptions.rectangle : false,
                marker: false
            },
            edit: options.edit ? {
                featureGroup: layer,
                remove: true,
                poly: {
                    allowIntersection: false,
                    showArea: true
                }
            } : false
        });

        worldMap.addControl(controls);
        worldMap.on('draw:editstop', _add);
        worldMap.on('draw:created', _add);
        worldMap.on('draw:deletestart', hide);
    };

    const removeLayer = () => {
        if (layer) {
            layer.clearLayers();
        }
    };

    const hide = () => {
        if (layer) {
            layer.clearLayers();
        }

        if (visible) {
            worldMap.removeControl(controls);
            worldMap.off('draw:editstop', _add);
            worldMap.off('draw:created', _add);
            worldMap.off('draw:drawstart', removeLayer);
            worldMap.off('draw:deletestart', hide);
            visible = false;
        }
    };

    const tooltipArea = (e) => {
        const drawnLayer = e.layer;

        if (drawnLayer instanceof L.Circle) {
            const radius = drawnLayer.getRadius();
            const center = drawnLayer.getLatLng();

            const readableRadius = radius >= 1000
                ? (radius / 1000).toFixed(2) + ' km'
                : radius.toFixed(0) + ' m';

            const earthRadius = 6378137;
            const deltaLat = (radius / earthRadius) * (180 / Math.PI);
            const topLat = center.lat + deltaLat;
            const topLng = center.lng;

            const topLatLng = L.latLng(topLat, topLng);
            const tooltipMarker = L.marker(topLatLng, { opacity: 0 });
            tooltipMarker
                .bindTooltip(`${translate('Common.Radius')}: ${readableRadius}`, {
                    permanent: true,
                    direction: 'top',
                    offset: L.point(-20, 30),
                })
                .addTo(layer)
                .openTooltip();
        }

        if (drawnLayer instanceof L.Polygon || drawnLayer instanceof L.Rectangle) {
            const latlngs = drawnLayer.getLatLngs()[0];
            const area = L.GeometryUtil.geodesicArea(latlngs);

            const readableArea = area >= 1000000
                ? (area / 1e6).toFixed(2) + ' km²'
                : area.toFixed(0) + ' m²';

            const topLat = latlngs.reduce((max, p) => p.lat > max ? p.lat : max, latlngs[0].lat);

            const minLng = latlngs.reduce((min, p) => p.lng < min ? p.lng : min, latlngs[0].lng);
            const maxLng = latlngs.reduce((max, p) => p.lng > max ? p.lng : max, latlngs[0].lng);

            const centerTopLatLng = L.latLng(topLat, (minLng + maxLng) / 2);

            const offsetMeters = 30;
            const earthRadius = 6378137;
            const deltaLat = (offsetMeters / earthRadius) * (180 / Math.PI);

            const tooltipLatLng = L.latLng(centerTopLatLng.lat + deltaLat, centerTopLatLng.lng);

            const tooltipMarker = L.marker(tooltipLatLng, { opacity: 0 });
            tooltipMarker
                .bindTooltip(`${translate('Common.Area')}: ${readableArea}`, {
                    permanent: true,
                    direction: 'top',
                    offset: L.point(0, 30),
                    interactive: false,
                })
                .addTo(layer)
                .openTooltip();
        }
    };

    const getControls = () => controls;

    return {
        visible,
        getLayer,
        getControls,
        removeLayer,
        hide,
        show
    };
})();

export default drawing;



// WEBPACK FOOTER //
// ./src/scripts/core/map/draw.js